<template>
  <b-row>
    <!-- Current Account Code -->
    <b-col sm="6" class="mb-2">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="current_account_code">{{ t('Current Account Code') }}</label>
        </div>
        <b-input-group>
          <b-form-input
            id="current_account_code"
            v-model="values.current_account_code"
            :placeholder="t('Enter Current Account Code')"
          />
          <b-input-group-append v-if="type === 'edit' && !values.current_account_code_initial">
            <b-button
              variant="primary"
              @click="$emit('update-current-account-code', values.current_account_code)"
              >{{ t('Update') }}</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <!-- Firma Bilgileri Title -->
    <b-col cols="12" class="mt-2">
      <h5 class="mb-1">Firma Bilgileri</h5>
    </b-col>

    <!-- Company Name -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="company_name">{{ t('Company Name') }}</label>
        </div>
        <b-form-input
          id="company_name"
          v-model="values.name"
          :placeholder="t('Company Name')"
          tabindex="3"
          readonly
        />
      </b-form-group>
    </b-col>

    <!-- Authorized No (type === 2) -->
    <b-col v-if="values.type === 2" sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="authorized_no">{{ t('Authorized No') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Authorized No')" rules="required">
          <b-form-input
            id="authorized_no"
            v-model="values.authorizedNo"
            name="authorized_no"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Authorized No')"
            tabindex="3"
            type="number"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Tax Office (type === 2) -->
    <b-col v-if="values.type === 2" sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="tax_office">{{ t('Tax Office') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Tax Office')" rules="required">
          <b-form-input
            id="tax_office"
            v-model="values.tax_office"
            name="tax_office"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Tax Office')"
            tabindex="3"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Tax Number (type === 2) -->
    <b-col v-if="values.type === 2" sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="tax_no">{{ t('Tax Number') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Tax Number')" rules="required">
          <b-form-input
            id="tax_no"
            v-model="values.tax_no"
            name="tax_no"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Tax Number')"
            tabindex="3"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Mersis Number (type === 2) -->
    <b-col v-if="values.type === 2" sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="mersis_number">{{ t('Mersis Number') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Mersis Number')" rules="required">
          <b-form-input
            id="mersis_number"
            v-model="values.mersis_number"
            name="mersis_number"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Mersis Number')"
            tabindex="3"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Trade Registry Number (type === 2) -->
    <b-col v-if="values.type === 2" sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="trade_registry_number">{{ t('Trade Registry Number') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider
          #default="{ errors }"
          :name="t('Trade Registry Number')"
          rules="required"
        >
          <b-form-input
            id="trade_registry_number"
            v-model="values.trade_registry_number"
            name="trade_registry_number"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Trade Registry Number')"
            readonly
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- İletişim Bilgileri Title -->
    <b-col cols="12" class="mt-2">
      <h5 class="mb-1">İletişim Bilgileri</h5>
    </b-col>

    <!-- Authorized Name Surname (finance) -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="authorized_name_surname_finance">{{ t('Authorized Name Surname') }}</label>
        </div>
        <b-form-input
          id="authorized_name_surname_finance"
          v-model="values.authorizedName"
          :placeholder="t('Authorized Name Surname')"
          tabindex="3"
          readonly
        />
      </b-form-group>
    </b-col>

    <!-- Email -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="email">{{ t('Email') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Email')" rules="required|email">
          <b-form-input
            id="email"
            v-model="values.email"
            name="email"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Email')"
            tabindex="8"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Phone -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="phone_finance">{{ t('Phone') }}</label>
        </div>
        <b-form-input
          id="phone_finance"
          v-model="values.phone"
          :placeholder="t('Phone')"
          type="number"
          tabindex="3"
          readonly
        />
      </b-form-group>
    </b-col>

    <!-- Adres Bilgileri Title -->
    <b-col cols="12" class="mt-2">
      <h5 class="mb-1">Adres Bilgileri</h5>
    </b-col>

    <!-- Country -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="country">{{ t('Country') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Country')" rules="required">
          <v-select
            id="country"
            v-model="values.country"
            :options="countries"
            :placeholder="t('Make a Choice')"
            label="text"
            @input="onCountryChange && onCountryChange($event)"
            :disabled="true"
          >
            <span slot="no-options">{{ t('No records found') }}</span>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Postal Code -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="postalCode">{{ t('Postal Code') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Postal Code')" rules="required">
          <v-select
            id="postalCode"
            :disabled="true"
            v-model="values.postalCode"
            :options="customerPostalCodeOptions"
            :placeholder="t('Enter Postal Code')"
            label="combinedLabel"
            @search="handleCustomerPostalCodeSearch && handleCustomerPostalCodeSearch($event)"
          >
            <span slot="no-options">{{ t('No records found') }}</span>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- City -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="city">{{ t('City') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('City')" rules="required">
          <v-select
            id="city"
            v-model="values.city"
            :options="cities"
            :placeholder="t('Make a Choice')"
            label="text"
            :disabled="true"
            @input="onCityChange && onCityChange($event)"
          >
            <span slot="no-options">{{ t('No records found') }}</span>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- District -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="state">{{ t('District') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('District')" rules="required">
          <v-select
            id="state"
            v-model="values.state"
            :options="districts"
            :placeholder="t('Make a Choice')"
            label="text"
            :disabled="true"
          >
            <span slot="no-options">{{ t('No records found') }}</span>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Company Type -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="companyType">{{ t('Company Type') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Company Type')" rules="required">
          <b-form-select
            id="companyType"
            v-model="values.companyType"
            name="companyType"
            :state="errors.length > 0 ? false : null"
            :options="[{ text: t('Make a Choice'), value: '' }].concat(companyTypes)"
            :disabled="true"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Address (moved below and full width) -->
    <b-col cols="12">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="address">{{ t('Address') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Address')" rules="required">
          <b-form-input
            id="address"
            v-model="values.address"
            name="address"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Address')"
            tabindex="3"
            readonly
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormSelect,
  BButton
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  name: 'CustomerFinanceForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    BButton,
    vSelect,
    ValidationProvider
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    values: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      default: () => []
    },
    cities: {
      type: Array,
      default: () => []
    },
    districts: {
      type: Array,
      default: () => []
    },
    companyTypes: {
      type: Array,
      default: () => []
    },
    customerPostalCodeOptions: {
      type: Array,
      default: () => []
    },
    onCountryChange: {
      type: Function,
      default: null
    },
    onCityChange: {
      type: Function,
      default: null
    },
    handleCustomerPostalCodeSearch: {
      type: Function,
      default: null
    }
  },
  emits: ['update-current-account-code'],
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
